module.exports = __webpack_public_path__ + "static/img/BG59.228ccc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BG59.jpg
// module id = 27bi
// module chunks = 1